<template>
  <v-container fluid>
    <v-container>
      <h1 class="text-h3">{{ $t("Statistic") }}</h1>
    </v-container>
    <v-container style="min-height: 100vh; height: 100%">
      <v-card tile class="pa-3" height="100%">
        <v-tabs align-with-title v-model="tab">
          <v-tabs-slider color="blue"></v-tabs-slider>
          <v-tab v-for="(value, key) in dashboards" :key="key">
            {{ key }}
          </v-tab>
        </v-tabs>
        <v-tabs-items v-model="tab">
          <v-tab-item
            v-for="(value, key) in dashboards"
            :key="key"
            style="height: 100%"
          >
            <dash-board :src="value" :location="$route.params.location_id" />
          </v-tab-item>
        </v-tabs-items>
      </v-card>
    </v-container>
  </v-container>
</template>

<script>
import DashBoard from "@/components/DashBoard";
import { mapActions, mapGetters } from "vuex";
export default {
  name: "LocationStatistic",
  components: { DashBoard },
  data() {
    return {
      tab: null,
    };
  },
  methods: { ...mapActions(["loadDashboards"]) },
  computed: { ...mapGetters(["dashboards", "dashboardsKeys"]) },
  mounted() {
    this.loadDashboards();
  },
};
</script>

<style scoped></style>
